"use strict";

/* -------------------------------------------------------------------------

	PUNITED.ph_news

	トップページのスクリプトを定義
	※jQuery必須
	Potential United inc.

------------------------------------------------------------------------- */

// グローバル名前空間定義
var PUNITED;
if (!PUNITED) PUNITED = {};
if (!PUNITED.ph_news) PUNITED.ph_news = {};
(function () {
  // グローバル名前空間オブジェクトをローカルオブジェクトに置き換え
  var ns = PUNITED.ph_news;

  /* -----------------------------------------------------
   ----------------------------------------------------- */
  ns.handleForm = function () {
    var form = document.querySelector('.news_form');
    var yearField = form.querySelector('#year');
    var categoryField = form.querySelector('#category');
    var btns = Array.from(document.querySelectorAll('.tab__btns li'));
    yearField.addEventListener('change', handleYearChange);
    btns.forEach(function (btn) {
      var a = btn.querySelector('a');
      a.addEventListener('click', handleBtnClick);
    });
    function handleYearChange(e) {
      btns.some(function (btn) {
        if (!btn.classList.contains('selected')) {
          return false;
        }
        var a = btn.querySelector('a');
        setCategoryField(a);
        return true;
      });
      form.submit();
    }
    function handleBtnClick(e) {
      e.preventDefault();
      if (e.currentTarget.parentNode.classList.contains('selected')) {
        return;
      }
      setCategoryField(e.currentTarget);
      form.submit();
    }
    function setCategoryField(a) {
      var url = new URL(a.href);
      categoryField.value = url.searchParams.get('_category');
    }
  };
})();
$(function () {
  PUNITED.useful.simpleTab(".tab", ".tab__btns", ".tab__contents");
  PUNITED.ph_news.handleForm();
});